import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './_search-gender-input.scss';
import GenderSelectDropdown from '../gender-select-dropdown/gender-select-dropdown';
import {clubFinderSearchBarSliceActions} from '../../../../../store/slices/clubFinderSearchBarSlice';
import {Config} from '../../../../../constants/Config';
import {RootState} from '../../../../../store/configureStore';

const baseClass = 'clubFinder-searchGenderInputBox';
const MobileViewWidth = Config.breakpoints.large.width;
interface PropTypes {
  inputBoxIcon?: string;
  label: string;
  placeholder?: string
  formatDetailsObject?: any
  genderOptions: any
}

const SearchGenderInput = (props: PropTypes): JSX.Element => {
  const dispatch = useDispatch();
  const ref = useRef<HTMLInputElement>(null);
  const activeSearchFilter: any = useSelector((state: RootState) => state.clubFinderSearchBarStore.activeSearchFilterMobile);
  const selectedGenderFilter = useSelector((state: RootState) => state.clubFinderSearchBarStore.selectedGenderFilter);
  const [isInputFocused, setInputFocus] = useState(false);
  const [isEditable, setEditable] = useState(false);
  const [isGenderSelectDropdownVisible, setGenderDropdownVisibility] = useState(false);
  const [isMouseOverResults, setIsMouseOverResults] = useState(false);
  const [genderOptionsSaved, setSavedGender] = useState(Config.defaultGenderOption.name)
  const parentWidth = useSelector((state: RootState) => state.widgetConfigurationSettings.widgetParentWidth);

  useEffect(() => {
    setGenderDropdownVisibility(activeSearchFilter.genderFilter);
    setSavedGender(selectedGenderFilter.name)
  },[activeSearchFilter. genderFilter,selectedGenderFilter])

  const handleFormatSelectAction = () => {
    setGenderDropdownVisibility(true);
    setEditable(false);
    dispatch(clubFinderSearchBarSliceActions.activeSearchFilterMobile({location: false, format: false, gender: true}))
  }


  const onBlurHandler = () => {
    if (!isMouseOverResults) {
      setInputFocus(false);
    }
  }

  const onMouseOverHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
    setIsMouseOverResults(true);
  }
  const onMouseOutHandler = (event: React.MouseEvent<HTMLDivElement>): void => {
    setIsMouseOverResults(false);
  }


  const saveGenderOption = (genderOption: any) => {
    setSavedGender(genderOption.name);
    dispatch(clubFinderSearchBarSliceActions.setSavedGenderFilter(genderOption))
    if (ref && ref.current) {
      ref.current.focus()
    }
  }

  const inputContainerClickedHandler  = () => {
    if (parentWidth > MobileViewWidth) {
      setInputFocus(true);
      if (ref && ref.current) {
        ref.current.focus();
      }
    }
  }

  return (
    <div
      onClick={inputContainerClickedHandler}
      className={`${baseClass} ${isInputFocused ? 'is-focused' : 'not-focused'}`}>
      <div className={`${baseClass}--header-button-wrapper`}>
        <div className={`${baseClass}--input-container`}>
          <div className={`${baseClass}--input-container-label`}>{props.label}</div>
          {isGenderSelectDropdownVisible && (
            <div className={`${baseClass}--sub-heading`}>How do you want to play?</div>
          )}
          {!isGenderSelectDropdownVisible && genderOptionsSaved && (
            <div className={`${baseClass}--selected-text`}>
              Selected format ({genderOptionsSaved})</div>
          )}
          <input
            onClick={() => setInputFocus(!isInputFocused)} placeholder={props.placeholder}
            onBlur={() => onBlurHandler()}
            ref={ref}
            type={'text'}
            readOnly={true}
            value={genderOptionsSaved && genderOptionsSaved !== Config.defaultGenderOption.name ? genderOptionsSaved : ''}/>
        </div>
        {!isGenderSelectDropdownVisible && (
          <div className={`${baseClass}--right-input-action`} onClick={handleFormatSelectAction}>
            {isEditable ? 'Edit' : 'Add'}
          </div>
        )}
      </div>
      {(isGenderSelectDropdownVisible || isInputFocused) && (
        <div className={`${baseClass}--gender-content-container`} onMouseOver={onMouseOverHandler}
             onMouseOut={onMouseOutHandler}>
          <GenderSelectDropdown genderOptions={props.genderOptions}
                                saveGenderOption={(gender: string) => saveGenderOption(gender)}/>
        </div>
      )}
    </div>
  )
}

export default SearchGenderInput;
